import { HttpClient } from '@angular/common/http';
import { API_CONSTANT } from './api.constant';
import * as _ from 'lodash';
import { ApiService } from './api.service';
var AuthenticationService = (function () {
    function AuthenticationService(http, apiService) {
        this.http = http;
        this.apiService = apiService;
    }
    AuthenticationService.prototype.login = function (username, password) {
        return this.http.post(API_CONSTANT.login, {
            username: username,
            password: password
        });
    };
    AuthenticationService.prototype.requestOtp = function (email) {
        return this.http.post(API_CONSTANT.request_otp, {
            email: email,
        });
    };
    AuthenticationService.prototype.validateOTP = function (password) {
        return this.http.post(API_CONSTANT.validate_otp, {
            password: password,
        });
    };
    AuthenticationService.prototype.updateUserInfo = function (user) {
        localStorage.setItem('userID', _.get(user, 'id'));
        localStorage.setItem('username', _.get(user, 'username'));
        localStorage.setItem('firstName', _.get(user, 'first_name'));
        localStorage.setItem('lastLame', _.get(user, 'last_name'));
        localStorage.setItem('isSuperUser', _.get(user, 'is_superuser'));
        localStorage.setItem('group', _.get(user, 'group'));
        localStorage.setItem('can_change_status_amount', _.get(user, 'can_change_status_amount'));
        localStorage.setItem('can_delete_document', _.get(user, 'can_delete_document'));
    };
    AuthenticationService.prototype.reloadUserInfo = function () {
        var _this = this;
        if (this.isLoggedIn()) {
            this.apiService.getMe().subscribe(function (user) {
                _this.updateUserInfo(user);
            });
        }
    };
    AuthenticationService.prototype.isLoggedIn = function () {
        return localStorage.getItem('currentUser') != null;
    };
    AuthenticationService.prototype.isAdmin = function () {
        return localStorage.getItem('group') === 'Admin' || localStorage.getItem('isSuperUser') === 'true';
    };
    AuthenticationService.prototype.isAccountant = function () {
        return localStorage.getItem('group') === 'Accountant';
    };
    AuthenticationService.prototype.isAccountantAdmin = function () {
        return localStorage.getItem('group') === 'Accountant Admin';
    };
    AuthenticationService.prototype.isIT = function () {
        return localStorage.getItem('group') === 'IT';
    };
    AuthenticationService.prototype.isCallCenter = function () {
        return localStorage.getItem('group') === 'Call Center';
    };
    AuthenticationService.prototype.isUIH = function () {
        return localStorage.getItem('group') === 'UIH';
    };
    AuthenticationService.prototype.isViewer = function () {
        return localStorage.getItem('group') === 'Viewer';
    };
    AuthenticationService.prototype.isViewerAudit = function () {
        return localStorage.getItem('group') === 'Viewer Audit';
    };
    AuthenticationService.prototype.isSystemAdmin = function () {
        return localStorage.getItem('group') === 'System Admin';
    };
    AuthenticationService.prototype.hasRequestEditPermission = function () {
        return localStorage.getItem('can_change_status_amount') === 'true';
    };
    AuthenticationService.prototype.hasRequestDeletePermission = function () {
        return localStorage.getItem('can_delete_document') === 'true';
    };
    return AuthenticationService;
}());
export { AuthenticationService };



// WEBPACK FOOTER //
// /opt/app/src/app/services/authentication.service.ts.pre-build-optimizer.js